import * as _components from './components'
import * as _containers from './containers'

export const components = _components
export const containers = _containers

export default { components, containers }
